import { ActivatedRouteSnapshot } from '@angular/router';
import { EnumContexto } from '../interfaces/topic.interface';

export const resolveContextoFromRoute = (route: ActivatedRouteSnapshot | null): EnumContexto | undefined => {
  const contextosValidos = Object.values(EnumContexto) as string[];
  let current = route;
  let contexto: EnumContexto | undefined;

  while (current) {
    const data = current.data?.contexto as string | undefined;
    if (data && contextosValidos.includes(data)) {
      contexto = data as EnumContexto;
    }
    current = current.firstChild;
  }

  return contexto;
};
